import React from 'react'
import './MenuDropdownLayout.scss'

const MenuDropdownLayout = ({children}) => {
    return <div className="main-menu__dropdown-layout">{children}</div>
}

export default MenuDropdownLayout
